/** @type {import('./translationTypes.js').Translations} */

const translations = {
	local: {
		region: 'en-US',
		language: 'Language',
		passedTimeInstant: 'now',
		passedTime1: '',
		passedTime2: ' ago',
		minute: 'minute(s)',
		hour: 'hour(s)',
		day: 'day(s)'
	},
	homepage: {
		title: 'The Legal OS',
		tagline:
			'Access reliable legal answers instantly. Draft, analyze, and master your documents with unparalleled precision and speed.',
		tryOrdalie: 'Try Ordalie',
		contactUs: 'Contact us',
		kpi1title: '100% hosted in France',
		kpi1content: 'Your data remains strictly in France and is never reused to train our models.',
		kpi2title: '8 hours saved on average per week/person',
		kpi2content:
			"Ordalie's clients, both companies and law firms, experience significant and lasting time savings.",
		kpi3title: '+2 Million official and reliable sources',
		kpi3content:
			'Ordalie relies solely on certified legal sources: codes, laws, case law, BOFiP, CNIL… updated daily.',

		card1title: 'Permanent legal anchoring',
		card1content:
			'All tasks are supervised by constant analysis against official legal sources, updated daily.',
		card1animation: '/animations/anim-1-sources-EN.json',
		card2title: 'Connect Ordalie to your knowledge',
		card2content: "Ordalie's value is multiplied by your years of experience and archives.",
		card2animation: '/animations/anim-3-vault-EN.json',
		card3title: 'Automated custom generation',
		card3content: 'Quickly create personalized and precise legal documents in just a few clicks.',
		card3animation: '/animations/anim-2-gen-EN.json',
		securitySectionTitle: 'PRIORITY TO SECURITY',
		securitySectionContent: `The security of your data is our priority at Ordalie. <span class="font-rethink font-medium">Hosted in France<sup>➀</sup></span>, our infrastructures comply with <span class="font-rethink font-medium">GDPR<sup>➁</sup></span> and meet <span class="font-rethink font-medium">SOC II<sup>➂</sup></span> and <span class="font-rethink font-medium">ISO 27001<sup>➃</sup></span> standards, ensuring advanced protection and continuous security of your sensitive information.`,
		outlineFig: 'Key figures',
		outlineFeatures: 'Features',
		outlineUsers: 'Users',
		outlineSecurity: 'Security',
		outlineResources: 'Resources',
		contactUsToLearnMore: 'Contact us to learn more'
	},
	user: {
		you: 'You',
		unknown: 'Unknown',
		loginOrSignup: 'Login | Signup',
		login: 'Login',
		logout: 'Logout',
		logoutConfirmation: 'Are you sure you want to logout?',
		signup: 'Signup',
		successLogin: 'Login success',
		sendingMagicLink: 'Sending login link...',
		magicLinkSent: 'Login link sent',
		verifyingLogin: 'Verifying login...',
		signingInWith: 'Signing in with {provider}...',
		expiredToken: 'The connection has expired, please log in again.',
		updateMsg: 'Your information has been updated',
		profile: 'Your Profile',
		organization: 'Organization',
		connectedOrganization: 'Connected Organization',
		organizationBenefits: 'Organization Benefits',
		orgBenefit1: "Secure access to your organization's data vault",
		orgBenefit2: 'Seamless collaboration with team members',
		orgBenefit3: 'Advanced document management and sharing',
		orgBenefit4: 'Centralized knowledge base',
		supportContact: 'For support or questions, contact:',
		onPremiseVersion: 'On-premise version for companies',
		profileMsg:
			'These informations will help me understand your expectations and adapt my answers to your profile 📝',
		name: 'Name',
		description: 'Description',
		askForConnection: 'Connect to access this feature.',
		haveAccessToFunctionality: 'You have access to this functionality !',
		editProfile: 'Edit my profile',
		subAndBilling: 'Subscription & billing',
		handleBilling: 'Manage my billing',
		myCustomerSpace: 'My customer space',
		customerSpace: 'Customer space',
		manageSubscription: 'Manage my subscription',
		subscriptionPaused: 'Subscription paused 🔔',
		subscriptionPausedMsg1:
			'Your Ordalie subscription is paused because we are unable to use the payment method linked to your subscription.',
		subscriptionPausedMsg2: 'Please check your payment information in your customer space.',
		editLanguage: 'Language',
		editLanguageMsg: "Choose the language in which you want to receive Ordalie's answers.",
		settings: 'Settings',
		loginToOrdalie: 'Login to Ordalie',
		signupToOrdalie: 'Access Ordalie',
		signupMsg1: 'Login to access ',
		signupMsg2: 'If you already have an account, you will be automatically redirected to it.',
		signupMsg3: 'By continuing, you accept our',
		signupMsg4: 'general conditions of use',
		signupMsg5: 'and our',
		signupMsg6: 'privacy policy',
		loginWithGoogle: 'Login with Google',
		loginWithMicrosoft: 'Login with Microsoft',
		or: 'or',
		loginWithEmail: 'Login with email',
		almostThere: 'You are almost there !',
		almostThereMsg1: 'We have sent you an email containing a temporary login link',
		almostThereMsg2: "Check your spam if you don't see it",
		openGmail: 'Open Gmail',
		openOutlook: 'Open Outlook',
		welcomePro: 'Welcome to Ordalie PRO ! 🎉',
		alreadyPro: 'You are already subscribed to Ordalie PRO 🎉',
		canceledPayment: 'The payment has been canceled.',
		companySize: 'Company size',
		currentPlan: 'Current plan',
		open: 'Open',
		upgradeToPro: 'Upgrade to Ordalie Pro',
		learnMore: 'Learn more',
		createOrganization: 'Create Organization',
		organizationName: 'Organization Name',
		organizationNamePlaceholder: 'Enter your organization name',
		organizationDescriptionPlaceholder: 'Enter a description for your organization',
		billingEmail: 'Billing Email',
		addBillingEmail: 'Add Billing Email',
		addBillingEmailDesc: 'Add a billing email to receive subscription and invoice updates',
		billingEmailUpdated: 'Billing email updated successfully',
		subscribeImmediately: 'Subscribe immediately',
		organizationTip:
			'Create an organization to collaborate with your team and manage your documents together.',
		organizationCreated: 'Organization created successfully',
		inviteMember: 'Invite Member',
		inviteSent: 'Invitation sent successfully',
		inviteAccepted: 'Invitation accepted successfully',
		confirmRemoveMember: 'Are you sure you want to remove this member?',
		memberRemoved: 'Member removed successfully',
		roleUpdated: 'Role updated successfully',
		organizationUpdated: 'Organization updated successfully',
		billingManagement: 'Billing Management',
		billingDescription: 'Manage your subscription and billing information in the customer portal.',
		accessBillingPortal: 'Access Billing Portal',
		details: 'Details',
		members: 'Members',
		billing: 'Billing',
		roleAdmin: 'Administrator',
		roleMember: 'Member',
		roleViewer: 'Viewer',
		user: 'User',
		role: 'Role',
		noOrganization: 'No Organization',
		noOrganizationDesc:
			'Create an organization to start collaborating with your team and manage your projects together.',
		preferences: 'Preferences',
		integrations: 'Integrations',
		// Account Information section
		accountInformation: 'Account Information',
		profilePicture: 'Profile Picture',
		uploadPhoto: 'Upload photo',
		photoRequirements: 'JPG, GIF or PNG. 1MB max.',
		photoConsentTitle: 'Photo Upload Consent',
		photoConsentMessage:
			'Your photo will be publicly visible and used for shared content. This helps personalize your experience and connect with others.',
		agreeAndUpload: 'Agree & Upload',
		uploadingPhoto: 'Uploading your photo...',
		photoUploaded: 'Photo uploaded successfully',
		deletingPhoto: 'Deleting your photo...',
		photoDeleted: 'Photo deleted successfully',
		nameDisplayed: 'Your name as displayed to other users.',
		emailContact: 'Contact support to change your email address.',
		briefDescription: 'Brief description for your profile.',
		// Company Information section
		companyInformation: 'Company Information',
		companyRecommendations: 'This helps us tailor our recommendations to your needs.',
		// Subscription section
		planComparison: 'Plan Comparison',
		features: 'Features',
		free: 'Free',
		pro: 'Pro',
		currentPlanLabel: 'Current Plan',
		recommended: 'Recommended',
		documentStorage: 'Document Storage',
		aiQueries: 'AI Queries',
		searchCapabilities: 'Search Capabilities',
		externalIntegrations: 'External Integrations',
		teamCollaboration: 'Team Collaboration',
		support: 'Support',
		limited: 'Limited',
		unlimited: 'Unlimited',
		noRestrictions: 'No restrictions',
		basic: 'Basic',
		advanced: 'Advanced',
		standard: 'Standard',
		community: 'Community',
		priority: 'Priority',
		responseTime: '24h response time',
		current: 'Current',
		premium: 'Premium',
		upgradeNow: 'Upgrade Now',
		testimonialQuote:
			'"Upgrading to Pro has saved our team countless hours on legal research and document preparation. The unlimited access and advanced features have been invaluable to our workflow."',
		testimonialAuthor: '— Sarah J., Legal Consultant',
		// Manage Subscription section
		subscription: 'Subscription',
		manageSubscriptionTitle: 'Manage Subscription',
		// Free Plan Details
		freePlanIncludes: 'Your free plan includes:',
		basicDocumentStorage: 'Basic document storage (up to 100MB)',
		standardSearchCapabilities: 'Standard search capabilities',
		communitySupport: 'Community support',
		upgradeToUnlock: 'Upgrade to unlock:',
		unlimitedDocumentStorage: 'Unlimited document storage',
		advancedAISearch: 'Advanced AI-powered search & analytics',
		prioritySupport: 'Priority support with 24-hour response time',
		// Pro Plan Details
		billingPeriod: 'Billing Period',
		monthly: 'Monthly',
		nextBillingDate: 'Next Billing Date',
		paymentMethod: 'Payment Method',
		allPremiumFeatures: 'All premium features unlocked',
		yearlyPlanActive: 'Your yearly subscription is active',
		monthlyPlanActive: 'Your monthly subscription is active',
		subscriptionAccessInfo:
			'You have access to all premium features. Manage your subscription or billing details through your customer portal.',
		noActiveSubscription: 'No Active Subscription',
		subscribeToUnlockFeatures:
			'Subscribe to unlock all premium features and enhance your experience.',
		yearly: 'Yearly',
		subscriptionActive: 'Subscription Active',
		// Integrations section
		connectedServices: 'Connected Services',
		proFeature: 'Pro Feature',
		proFeatureLimited: 'Pro Feature Limited',
		connectAccounts: 'Connect your accounts to import and sync your documents automatically.',
		upgradeForIntegrations: 'Upgrade to Pro for full integration capabilities.',
		microsoft: 'Microsoft',
		google: 'Google',
		disconnected: 'Disconnected',
		connect: 'Connect',
		requiresProPlan: 'Requires Pro Plan',
		microsoftServices: 'Connect to OneDrive, SharePoint, and other Microsoft services.',
		googleServices: 'Connect to Google Drive, Gmail, and other Google services.',
		// Coming Soon section
		comingSoon: 'Coming Soon',
		dropbox: 'Dropbox',
		slack: 'Slack',
		notion: 'Notion',
		syncDropbox: 'Sync your Dropbox files',
		connectSlack: 'Connect to your Slack workspace',
		importNotion: 'Import from Notion databases',
		// Language & Region section
		languageRegion: 'Language & Region',
		chooseLanguage: 'Choose your preferred language for the interface.',
		// Appearance section
		appearance: 'Appearance',
		darkMode: 'Dark Mode',
		toggleTheme: 'Toggle between light and dark theme',
		toggleThemeButton: 'Toggle Theme',
		// Tutorials & Help section
		tutorialsHelp: 'Tutorials & Help',
		resetTutorials: 'Reset all tutorial hints and guidance to see them again.',
		resetTutorialsButton: 'Reset tutorials',
		// Security section
		security: 'Security',
		mfaIntro: 'Add an extra layer of security to your account.',
		enableMfa: 'Enable 2FA',
		disableMfa: 'Disable 2FA',
		mfaCode: 'Authentication code',
		mfaVerificationInfo: 'Enter the 6-digit code from your authenticator app.',
		mfaSetupInfo: 'Scan the QR code with your authenticator app, then enter the generated code.',
		mfaEnabled: 'Two-factor authentication enabled',
		mfaDisabled: 'Two-factor authentication disabled',
		mfaEnabledInfo: 'Your account is protected with two-factor authentication. You will need to enter a code from your authenticator app each time you log in.',
		mfaDisabledInfo: 'Enable two-factor authentication to add an extra layer of security to your account.',
		multifactorAuth: 'Two-Factor Authentication',
		mfaDescription: 'Protect your account with a second layer of security using an authenticator app.',
		enabled: 'Enabled',
		disabled: 'Disabled',
		// Admin section
		apiConfiguration: 'API Configuration',
		apiRootURL: 'API Root URL',
		advancedSettings: 'Advanced Settings',
		adminSettingsInfo: 'Additional admin settings and tools will appear here.',
		active: 'Active',
		inactive: 'Inactive'
	},
	label: {
		chat: 'Assistant',
		documents: 'Documents',
		write: 'Smart Document Generator',
		search: 'Library',
		analyze: 'Document Audit Tool',
		notes: 'Notes',
		settings: 'Settings',
		productUpdates: 'Product updates',
		myAccount: 'Account',
		training: 'Learn',
		darkMode: 'Dark mode',
		lightMode: 'Light mode',
		menu: 'Menu',
		recentConversations: 'Recent conversations',
		recentDocuments: 'Recent documents',
		noDocuments: 'No documents',
		noNotes: 'No notes',
		noConversations: 'No conversations',
		updates: 'Updates',
		feedbackRequest:
			'Have ideas to improve Ordalie? Don\'t hesitate to <a href="mailto:support@ordalie.com?subject=Feature%20Suggestion" class="text-royal-blue hover:text-royal-blue/80 font-medium">write to us</a>, we love getting your feedback!',
		feedbackSignature: 'The Ordalie team'
	},
	status: {
		trial: 'Trial',
		late: 'Late',
		free: 'Free',
		becomePro: 'Upgrade to Ordalie Pro',
		monthly: 'Monthly',
		yearly: 'Yearly',
		vatExcluded: 'All prices are in EUR and do not include VAT'
	},
	offer: {
		pricingTitle: 'Clear, flexible and always fair',
		pricingSubtitle: 'Get access to the most advanced AI legal assistant, tailored to your needs',
		freeForever1: 'Free',
		freeForever2: 'forever',
		freeIntro: 'Start exploring',
		actualOffer: 'Current plan',
		freeAIModel: 'Basic AI models',
		freeQueries: '10 queries / week',
		freeHistoricalRecords: '7 days history',
		freeSearchEngine: 'Search engine access',
		freeCreateNotes: 'Note creation',
		proTitle: 'Ordalie PRO',
		proSubtitle: 'For professionals',
		proIntro: 'Advanced legal tech',
		proPriceCondition: 'excl. VAT/month/user',
		proSouscriptionButton: 'Upgrade to Pro',
		cancelAnytime: 'Cancel anytime',
		proAIModel: 'Advanced AI models',
		proQueries: 'Unlimited queries',
		proHistoricalRecords: 'Unlimited history',
		proSearchEngine: 'Advanced search engine',
		proCreateNotes: 'Enhanced note creation',
		proImportDocuments: 'Import your own documents',
		proGenerateContracts: 'Generate all your contracts',
		proAnalyseDocuments: 'Detailed legal analysis',
		enterpriseTitle: 'Custom Solution',
		enterpriseSubtitle: 'Ordalie Vault',
		enterpriseContact: 'Contact for pricing',
		enterpriseFeatures: 'Everything in Pro',
		enterpriseOnPremise: 'Deploy on your servers with full control over your data',
		enterpriseAI: 'AI-powered document exploitation',
		enterpriseVolume: 'Volume discount pricing',
		enterpriseManager: 'Dedicated success manager',
		enterpriseOnboarding: 'Custom onboarding',
		enterpriseSupport: 'Priority support',
		customizedNeed1: 'For custom needs, ',
		customizedNeed2: 'contact us',
		subscriptionSuccess: 'Welcome to Ordalie Pro 🎉',
		thanksForSubscription: 'Thank you for your trust!',
		alreadyPro: 'You are already subscribed 🎉'
	},
	chat: {
		greetingDay: 'Hello',
		greetingNight: 'Good evening',
		introduction:
			"I'm Ordalie, a French legal AI. I have access to millions of legal sources (codes, laws, jurisprudence, AAI...). \nAsk me questions or ask me to write documents!",
		appelForInscription: 'Inscrivez-vous simply first to talk to me.',
		callForPro1: 'I am not a lawyer, please check the information before using it. Consider ',
		callForPro2: 'for more reliability and security.',
		tryPro: 'Try Pro',
		disclaimer: 'Ordalie can make mistakes. Consider checking important information.',
		freeGoPro:
			'You are on our free plan. <a class="text-royal-blue contrast-200 cursor-pointer hover:underline" onclick={window.handleProClick()}>Go PRO</a>',
		conversations: 'Conversations',
		conversationSingle: 'Conversation',
		historyConversations: 'History',
		archiveConversation: 'Archive the conversation',
		deleteConversation: 'Delete the conversation',
		deleteConversationContent: 'Are you sure you want to delete this conversation ?',
		newConversation: 'New conversation',
		renameConversation: 'Rename conversation',
		deleteMessage: 'Delete the message',
		deleteMessageConfirmation: 'Are you sure you want to delete this message ?',
		deleteAnalysis: 'Delete the analysis',
		deleteAnalysisConfirmation: 'Are you sure you want to delete this analysis ?',
		copyWithSources: 'Copy the response with the sources',
		includeQuestion: 'Include the question',
		includeJustification: 'Include the justification',
		dislike: 'Negative evaluation',
		like: 'Positive evaluation',
		messageOptions: 'Message options',
		noData: 'No data',
		inputLabel: 'Text area',
		inputPlaceholderSearch: 'Tell me what you need... (@ to attach a document)',
		inputPlaceholderAnalysis: 'Ask anything about your documents... (@ to attach a source)',
		inputPlaceholderWrite:
			'Describe the document(s) you want to generate... (@ to attach a document)',
		dropToAttach: 'Drop the document here',
		seeBeginning: 'See the beginning of the conversation',
		error: 'An error occurred. Retry or rephrase your question.',
		login: 'Please login to talk to Ordalie.',
		limitReached:
			'You have reached the limit of 10 messages per week 😗\n Upgrade to **Ordalie Pro** to enjoy unlimited messages and a more performant AI.',
		// <br> <button class='px-8 py-1 rounded-lg bg-ord-blue text-md  mt-4 h-12 font-medium' onclick={window.handleProClick()}>Ordalie Pro</button>
		docGenerated: 'Here is your generated document:',
		archivedConversationsMsg: 'Your past conversations will appear here!',
		noArchivedConversationsMsg1: 'No conversation related to the term "',
		noArchivedConversationsMsg2: '" 😢',
		limitArchivedConversations1: 'You are limited to the last 7 days of conversations.',
		limitArchivedConversations2: 'Upgrade to',
		limitArchivedConversations3: 'for unlimited history.',
		limitConversationsAtteinte: 'Limit reached. Upgrade to Ordalie PRO for unlimited experience.',
		exportToXLSX: 'Export to Excel',
		usedConversations: '/10 queries performed',
		chatloadingMsg1: 'Understanding the request',
		chatloadingMsg2: 'Taking into account the context',
		chatloadingMsg3: 'Writing the response',
		writeQuestion: 'Write your question...',
		exportAnswer: 'Copy the answer (with sources)',
		exporterAsPDF: 'Export to PDF',
		exporterAsWord: 'Export to Word',
		exportInProgress: 'Export in progress...',
		exportSuccessful: 'Export successful',
		question: 'Question',
		answer: 'Answer',
		searching: 'Searching...',
		results: 'Results',
		all: 'All',
		documentNotFound: 'Document not found',
		errorDocumentNotFoundMsg: 'The requested document could not be found',
		errorLoadingDocument: 'Error loading document',
		errorLoadingShortMsg: 'Loading error',
		processingDocument: 'The document is being processed',
		loadingShortMsg: 'Loading...',
		generatingShortMsg: 'Generating...',
		editingShortMsg: 'Editing document...',
		readyShortMsg: 'Ready',
		untitled: 'Untitled',
		search: 'Search',
		thinkingTitle: 'Reasoning...'
	},
	sources: {
		sources: 'Sources',
		userDocuments: 'My documents',
		userDocumentsSubtitle: 'Here you will find all the documents you have generated and imported.',
		documents: 'Documents',
		singleSource: 'Source',
		internalSources: 'Internal sources',
		activeSources: 'active sources',
		manageSources: 'Manage your sources',
		tableType: 'Tableau',
		annexType: 'Annexe',
		articleType: 'Article',
		addUrlSourceMsg: 'Enter the URL of the website to add to your sources',
		addSitesMsg: "Add your favorite websites to Ordalie's sources 👆",
		apiaddDocumentMsg: "Add your own documents to Ordalie's sources 🔒",
		apiworkingOnDocumentsMsg: 'Working on your own documents in Ordalie 🔒',
		sourceAlreadyAdded: 'This source is already added',
		addSourceSuccess: 'Source added',
		sourceLinkInaccesible: 'The link is inaccessible or not valid.',
		addContentToContext: 'Add content to the context',
		chooseDocuments: 'Choose documents',
		chosedDocuments: 'Documents selected',
		chosedDocumentSingle: 'Document selected',
		importDocument: 'Import a document',
		importDocuments: 'Import documents',
		importDocumentSuccess: ' has been imported',
		importDocumentsMsg: 'Drag your documents here to analyze them',
		noDocuments: "You don't have any documents yet",
		noResults: 'No results',
		emptyFolder: 'The folder is empty',
		chosedSources: 'Sources selected',
		chosedSourceSingle: 'Source selected',
		selectAll: 'Select all',
		deselectAll: 'Deselect all',
		documentName: 'Name',
		documentDate: 'Date',
		documentActions: 'Actions',
		addDocumentMsg: 'Add your documents in a secure space on Ordalie 🔒',
		addDocumentMsg2: 'Your documents are secure and accessible <u>only by you</u>.',
		addDocument: 'Add a document',
		addDocumentToSources: 'Add to sources',
		addDocumentSuccess: ' has been added',
		addingDocument: 'Adding document...',
		addingDocumentSuccessMsg: 'You can leave this screen, you will find it in your documents',
		addToSources: 'Add to sources',
		addToDocument: 'Add to document',
		addToDocumentMsg: 'Do you want to attach this text as a document to analyze ?',
		removeFromSources: 'Remove from sources',
		addDocumentToSourcesMsg: 'Do you want to add this document to the search ?',
		addDocumentToSourcesSubtext: 'Only the current version will be added to the sources.',
		renameDocument: 'Rename the document',
		addTag: 'Add a tag',
		addTagMsg: 'Tags allow you to sort your documents. Add as many as you want.',
		tags: 'Tags',
		createNew: 'New tag',
		tagsAddedSuccess: 'Tags added',
		tagsRemovedSuccess: 'Tag removed',
		searchTags: 'Search tags or documents...',
		clickToView: 'Click to view documents',
		removeDocumentConfirmation: 'Delete the document(s) ?',
		removeDocumentAlert: 'This action is irreversible.',
		removeDocumentSuccess: 'Document deleted',
		removeDocumentFromSources: 'Remove from sources',
		removeDocumentFromSourcesMsg: 'Do you want to remove this document from the search sources ?',
		removeDocumentFromSourcesSucess: 'The document has been removed from the search sources',
		addDocumentToSourcesSuccess: 'The document has been added to the sources',
		documentAlreadyAdded: 'This document has already been added',
		pleaseAddDocumentsToAnalyze: 'Please add documents to analyze',
		removeUrlSource: 'Remove source',
		removeUrlSourceConfirmation: 'Do you really want to remove this source ?',
		removeSearchSource: 'Remove source',
		removeSearchSourceConfirmation:
			'Do you really want to remove this document from the search sources ?',
		removeSearchSourceSuccess: 'The document has been removed from the search sources',
		sourcesOfOrdalie: 'Sources of Ordalie',
		sourcesOfOrdalieMsg1: 'Ordalie is based on millions of sources constantly updated.',
		sourcesOfOrdalieMsg2: 'You can complete these sources with ',
		sourcesOfOrdalieMsg3: 'your own documents',
		sourcesOfOrdalieMsg4: ' (in a fully isolated space) or ',
		sourcesOfOrdalieMsg5: 'index internet sites',
		sourcesOfOrdalieMsg6: ' that you regularly visit.',
		chooseSourcesMsg:
			'Select the different sources on which you want Ordalie to rely to answer you.',
		sourcesFromInternet: 'Internet sites',
		callForProForMoreSources: 'You must have PRO to add more than 2 sources.',
		callForProForAddDocuments: 'You must have PRO to add your documents to the sources',
		legalSources: 'Legal sources',
		codesSources: 'Codes',
		expand: 'Expand',
		generateWithAI: 'Generate with AI',
		limitDocuments: 'You have reached the limit of documents for your free account',
		newDocument: 'New document',
		documentGeneratedMsg1: 'In this section you will find all the documents written with Ordalie.',
		documentGeneratedMsg2: 'You will also be able to write new documents.',
		searchSources: 'Search sources',
		recentSearches: 'Recent searches',
		activateSource: 'Activate',
		deactivateSource: 'Deactivate',
		resetSearch: 'Reset the search',
		sourcesNumber: 'element(s)',
		downloadDocument: 'Download document',
		downloadAnonymizeDocument: 'Anonymize document',
		downloadDocumentSuccess: 'Document downloaded',
		removeFromList: 'Remove from list',
		documentTitle: 'Document title',
		pinSource: 'Pin source',
		noResultsFor: 'No results for',
		repealed: 'Repealed',
		amended: 'Amended',
		inForce: 'In force',
		indent: 'Increase indent',
		outdent: 'Decrease indent',
		noTags: 'No tags',
		noTagsTitle: 'Organize with tags',
		noTagsSubtitle: 'Start by searching and tagging your first document',
		noTagsFeature1: 'Group documents and sources under the same tag',
		noTagsFeature2: 'Reference in chat using',
		noTagsFeature3: 'Keep track of cases, dossiers, or research topics',
		createTagsDescription: 'Create tags to organize your documents and find them more easily.',
		noDocumentsWithTag: 'No documents with this tag',
		addTagToDocuments: 'Add this tag to your documents to find them here.',
		tagDeleted: 'Tag deleted',
		errorDeletingTag: 'Error deleting tag',
		document: 'Document',
		documentUploadedSuccess: 'Document uploaded successfully',
		documentUploadedError: 'Error uploading document',
		sharedWithYou: 'Shared with you'
	},
	notes: {
		notes: 'Notes',
		noteSingle: 'Note',
		userNotes: 'My notes',
		notesMsg1: 'Here you will find all your notes taken during your searches.',
		notesMsg2: 'To add a note, click on the button ',
		notesMsg3:
			'on a source (article, law-case, etc.). You will also have the possibility to add text directly to the note.',
		searchForNotes: 'Search for notes',
		error: 'An error occurred while loading the notes. Please try again.',
		deleteNoteConfirmation: 'Do you want to delete this note ?',
		notePlaceholder: 'Write your note here...',
		removeAllTags: 'Remove all tags',
		removeAllTagsConfirmation1: 'Do you want to remove all tags under the label "',
		removeAllTagsConfirmation2: '" ?',
		removeAllTagsSuccess1: 'All tags (',
		removeAllTagsSuccess2: ') have been removed',
		removeAllTagsError: 'Error removing tags',
		removeAllTagsAlert: 'This action is irreversible.',
		rightClickToDelete: 'Right-click to delete'
	},
	writing: {
		intent: 'write|redact',
		aiWriting: 'AI Writing',
		aiEdit: 'AI Edit',
		aiRewrite: 'AI Rewrite',
		aiAssistant: 'AI Assistant',
		textEditor: 'Text Editor',
		textEditorAria: 'Modify, improve or generate text',
		writing: 'Writing',
		generate: 'Generate the next',
		insert: 'Insert',
		passage: 'Passage',
		generateFromPassage: 'Generate from the passage',
		rewriteWithContext: 'Rewrite with the context',
		reformulation: 'Reformulation',
		fluidize: 'Improve the fluidity',
		correction: 'Correction',
		shorten: 'Shorten',
		develop: 'Develop',
		rewriteInTable: 'Rewrite in table',
		correctSpelling: 'Correct the spelling',
		restart: 'Restart',
		replace: 'Replace',
		insertBelow: 'Insert below',
		inspireRewrite: 'Inspire rewrite',
		similarPassages: 'Similar passages',
		selectedText: 'Selected text',
		selectionTooLong: 'Selection too long',
		searchSimilarPassages: 'Search similar passages',
		seeSimilarPassagesMsg1: 'See ',
		seeSimilarPassagesMsg2: ' passage(s) similaire(s)',
		pleaseSelectAPassage: 'Please select a passage to analyze',
		createYourFirstAnalysis: 'Create your first analysis',
		clearAll: 'Clear all',
		bold: 'Bold',
		italic: 'Italic',
		underline: 'Underline',
		generation: 'Generation...',
		instructionForWriting: 'Instruction for writing...',
		instructionForRewrite: 'Instruction for rewrite...',
		aiAnalyze: 'Analyze with the AI',
		analyzePassageWithAI: 'Analyze passage with the AI',
		describeDocumentToGenerate: 'Please describe the document to generate',
		documentGeneration: 'Document generation',
		documentGeneratePlaceholder: 'Ex: Contract of employment, Contract of service...',
		documentModel: 'Document model',
		addDocumentModel: 'Add document model',
		generateDocument: 'Generate document',
		generateAllDocuments: 'Generate all documents',
		generateBrief: 'Generate brief',
		documentBrief: 'Document brief...',
		documentStructure: 'Document structure',
		modificationMsg: 'You can modify all the texts of the brief, and reorder the parts.',
		templates: 'Analysis templates',
		useTemplate: 'Use template',
		newTemplate: 'New template',
		newTemplateMsg: 'Click on <i>New template</i> to create a new analysis chain!',
		analysisTemplateTitle: 'Template title',
		analysisPromptMsg: 'Add questions to your template. They will be asked in order.',
		deleteTemplateSuccess: 'Template has been deleted',
		loadedTemplate: 'Template loaded',
		invalidDocumentStructure: 'Invalid document structure.',
		showStructure: 'Show structure',
		describeRewrite: 'Describe how you want to rewrite the selected text',
		describeWrite: 'Describe what you want to write'
	},
	comment: {
		addComment: 'Add a comment',
		replyToThread: 'Reply to thread'
	},
	summary: {
		summary: 'Summary',
		disclaimer: 'This summary was generated by AI, it may contain errors.'
	},
	analyses: {
		analysis: 'Analysis',
		analyses: 'Analyses',
		summary: 'Summary',
		dateAndDelays: 'Dates and delays',
		attentionPoints: 'Attention points',
		partiesPrenantes: 'Stakeholders',
		beginner: 'Beginner',
		intermediate: 'Intermediate',
		advanced: 'Advanced',
		expert: 'Expert',
		passageNotFound: "The cited passage doesn't exist in the document anymore"
	},
	error: {
		generalError: 'An error occurred.',
		generalErrorMsg: 'An error occurred',
		generalErrorTryLaterMsg: 'An error occurred, please try again later.',
		invalidMagicLink: 'The link is not valid, please try again.',
		invalidMfaCode: 'The code is incorrect.',
		errorLoadingConversation: 'Error loading the conversation.',
		errorLoadingConversationMsg: 'An error occurred while loading the conversation.',
		documentNotFound: 'Document not found',
		retry: 'Try again',
		resend: 'Resend',
		errorLoadingShortMsg: 'error loading',
		errorFetchDocument: 'Unable to retrieve the document',
		errorFetchComments: 'Unable to retrieve the comments',
		errorGenerateDocument: 'An error occurred while generating the document',
		errorDownloadDocument: 'Error during download',
		errorSearchSources: 'Error during search of sources',
		errorFreeDocLimitReached: 'You have reached the limit of documents for your free account',
		errorDocLimitReached: 'You have reached the limit of documents',
		errorImportDocument: 'Error : impossible to import this(these) document(s)',
		errorEmailNotValid: 'Please enter a valid email address',
		errorNotLogged: 'You must be logged in to access this feature',
		errorLoadingSource: "We couldn't retrieve this source :/",
		errorDocumentNotFound: 'Document not found',
		errorDocumentNotReadyMsg: 'Please wait for the document to be ready',
		exportFailed: 'Export failed',
		tooManyRequests: 'You are making too many requests, please try again later',
		sttError: 'Error during speech-to-text',
		microphoneAccess: 'Microphone access denied, please try again',
		required: 'This field is required',
		field_required: 'Please fill in the required field',
		all_fields_required: 'Please fill in all required fields to continue',
		inviteError: 'An error occurred while accepting the invitation'
	},
	footer: {
		resourcesTitle: 'Resources',
		pricing: 'Pricing',
		news: 'News',
		docs: 'Documentation',
		devApi: 'Developer API',
		cgu: 'Conditions',
		cgv: 'Sales conditions',
		privacy: 'Privacy',
		privacyPolicy: 'Privacy policy',
		press: 'Press',
		contactUs: 'Contact us',
		needHelp: 'Need help ?',
		joinUs: 'Join us',
		followUs: 'Follow us',
		rights: 'All rights reserved.',
		generalConditions: 'General conditions of use',
		salesConditions: 'Sales conditions',
		publicRelation: 'Press Relation'
	},
	home: {
		home: 'Home',
		about: 'About',
		app: 'Use our AI',
		news: 'News',
		aboutOrdalie: 'About Ordalie',
		aboutOrdalieMsg1: 'Today, Ordalie is in beta.',
		aboutOrdalieMsg2:
			'This means you can use the service for free, but you are limited to 10 messages/week to our AI.',
		aboutOrdalieMsg3:
			'The project is moving fast, we will soon integrate more features as well as new legal sources (collective agreements, UE regulations, etc.)',
		aboutOrdalieMsg4: 'The project is mainly led by ',
		titleOfLea: 'lawyer and data-analyst',
		titleOfBaudouin: 'full-stack developer and data-scientist'
	},
	news: {
		dailyNews: 'The latest news',
		lastNews: 'Last news'
	},
	info: {
		share: 'Share',
		loadingShortMsg: 'loading',
		loading: 'Loading...',
		loadingDocumentation: 'Loading documentation...',
		lastUpdatedOn: 'Last updated on',
		tableOfContents: 'Table of contents',
		docsExploreGuides:
			"Ordalie does many things, but it can quickly become a bit abstract. So we've prepared this documentation to help you get the most out of it. And if you have any questions, we're here for you!",
		docsClickToExplore: 'Click to explore this section',
		docsMoreSubsections: '+ {count} more',
		docsSubSections: 'subsections',
		docsExploreDocumentation: 'Explore documentation',
		confirm: 'Confirm',
		cancel: 'Cancel',
		searching: 'Ask your question or make a request...',
		search: 'Search',
		send: 'Send',
		sending: 'Sending...',
		answer: 'Répondre...',
		thanksForFeedback: 'Thank you for your feedback!',
		yourOpinionIsImportant: 'Your opinion counts!',
		continue: 'Continue',
		add: 'Add',
		link: 'Link',
		openLink: 'Open the link',
		openFile: 'Open the file',
		openPage: 'Visit the page',
		openLegifrance: 'Visit the article on Legifrance',
		openEurLex: 'Visit the article on Eur-Lex',
		delete: 'Delete',
		return: 'Return',
		copied: 'Text copied',
		copy: 'Copier',
		copiedIntoClipboard: 'Text copied into the clipboard',
		download: 'Download',
		downloading: 'Downloading...',
		previous: 'Previous',
		next: 'Next',
		redo: 'Redo',
		canceledImport: 'Import canceled',
		anonymize: 'Anonymize',
		anonymizing: 'Anonymizing...',
		singleFileImported: '1 file imported',
		close: 'Close',
		start: 'Start',
		finish: 'Finish',
		tryAgain: 'Try again',
		refresh: 'Refresh',
		or: 'or',
		sendButton: 'Send button',
		minimize: 'Minimize',
		inProgress: 'In progress...',
		update: 'Update',
		save: 'Save',
		date: 'Date',
		maintenanceMsg1: 'Ordalie is in maintenance.',
		maintenanceMsg2: 'We are back very soon! 👩🏼‍💻',
		dateFilterAvailableSoon: 'Date filter available soon',
		availableSoon: 'Available soon',
		multipleFilesImported: ' files imported',
		seeMore: 'See more',
		processingDocument: 'This document is being processed',
		generate: 'Generate',
		open: 'Open',
		hide: 'Hide',
		comment: 'Comment',
		optional: 'optional',
		generating: 'Generating...',
		regenerate: 'Regenerate',
		clickToAccess: 'Click to access',
		export: 'Export',
		startRecording: 'Start recording',
		stopRecording: 'Stop recording',
		generationInProgress: 'Document generation in progress...',
		more: 'More...',
		selected: 'Selected',
		generationComplete: 'Document generation complete!',
		sortAlphabetically: 'Sort alphabetically',
		sortByCount: 'Sort by count',
		sortByRecent: 'Sort by recent',
		sortLabelAlphabetical: 'A-Z',
		sortLabelCount: 'Count',
		sortLabelRecent: 'Recent'
	},
	vault: {
		whatIsOrdalieVault: 'What is Ordalie Vault?',
		aboutVaultmsg1: ' is a secure server connected to the internal knowledge base of ',
		aboutVaultmsg2: 'Internal documents complement the ',
		aboutVaultmsg3: 'millions of sources',
		aboutVaultmsg4: ' of Ordalie to multiply the power and relevance of our AI models.',
		aboutVaultmsg5: 'You notably benefit from:',
		aboutVaultmsg6: 'Legal research based on your internal knowledge',
		aboutVaultmsg7: 'Contract drafting support based on your clause history',
		aboutVaultmsg8: 'Many other features to come...',
		aboutVaultmsg9: 'For any question, a dedicated support is available at the address: ',
		connecting: 'Connecting...',
		connectedTo: 'Connected to ',
		disconnectedFrom: 'Disconnected from ',
		syncedDocuments: ' documents synchronized',
		currentlyUnavailable: 'currently unavailable',
		description:
			'Ordalie Vault is an on-premise module that connects Ordalie to your IS and enhances your internal data. Benefit from advanced search, personalized suggestions, and fluid document generation, directly from your sources.'
	},
	onboarding: {
		welcomeToOrdalie: 'Welcome to Ordalie',
		askForName: 'What is your name?',
		askForCompanySize: 'What is the size of your company?',
		askForActivity: 'What is your activity?',
		askForActivityMsg: 'This will help me provide more relevant answers',
		finalMsg: 'Everything is ready!',
		useOrdalie: "Let's start using Ordalie",
		activityPlaceholder1: 'I am a lawyer specialized in business law...',
		activityPlaceholder2: 'I am a business owner in the tech industry...',
		singlePerson: 'person',
		multiplePeople: 'people',
		loadingData: 'Loading your data',
		finalizingProfile: 'Finalizing your profile',
		privacyTitle: 'Data protection is our priority',
		privacyHosting: {
			title: '100% French hosting',
			content: 'Your data is hosted exclusively in France on secure and certified servers.'
		},
		privacyGDPR: {
			title: 'GDPR Compliance',
			content:
				'We strictly comply with GDPR and your rights. You maintain complete control over your data.'
		},
		privacyNoReuse: {
			title: 'No data reuse',
			content: 'Your data is never used to train our AI models. It remains strictly confidential.'
		},
		privacyConsent:
			"I understand and agree that my data will be processed in accordance with Ordalie's",
		privacyPolicy: 'privacy policy'
	},
	faq: {
		question1: 'How does Ordalie work ?',
		answer1:
			'Ordalie uses an AI technology to read and understand French law articles, in order to answer your questions on the law.',
		question2: "Can I trust Ordalie's answers ?",
		answer2:
			'Ordalie is trained with reliable and up-to-date legal data, but it is always recommended to consult a lawyer for personalized advice.',
		question3: "Are Ordalie's answers free ?",
		answer3: 'Yes, the answers are currently free for all users, within the limit of 10 per week.',
		question4: 'How can I contact Ordalie ?',
		answer4: 'You can contact the team behind Ordalie at the address support@ordalie.tech',
		question5: 'Are my informations protected when using Ordalie ?',
		answer5:
			"Yes, we take your privacy very seriously. Please refer to our <a class='underline' href='/legal/cgu' target='_blank' rel='noreferrer'>terms of use</a> for more details on how we protect your data."
	},
	training: {
		title: 'Discover Ordalie',
		subtitle: "Follow different missions to learn how to use the full power of Ordalie's features.",
		addPoint: 'points !',
		missionCompleted1: 'Mission',
		missionCompleted2: 'completed !',
		completed1: 'Completed !',
		completed2: 'Finished !',
		completed3: 'Concluded !',
		introCat: 'Get started on Ordalie',
		intro1title: 'Create your Ordalie account',
		intro1desc:
			"Create an Ordalie account to access all the platform's features. At first, if you are reading this, you have probably already completed this task! 🎉 <br> Keep going like this!",
		intro2title: 'Fill in the description of your profile',
		intro2desc:
			'The profile description will help Ordalie better adapt its answers to your needs. You can modify it at any time in the <a href="/settings">settings</a> of your account with the "Edit my profile" button.',
		rechCat: 'Use the chat',
		rech1title: 'Perform a search in the chat',
		rech1desc:
			'Ask a legal question in the <a href="/app/chat">chat</a> and get an answer. Ordalie will answer you directly if the question is sufficiently precise, citing all the consulted sources to give you a reasoned answer. If the question is too vague, Ordalie will ask you for more details to refine its answer.',
		rech2title: 'Add a document in context',
		rech2desc:
			'You can add a document in context in the chat to ask a question on a specific document. To do this, click on the "+" button on the left side of the chat input field and select the document to add.',
		rech3title: 'Generate a legal document via the chat',
		rech3desc:
			'The chat also allows you to generate legal documents based on the context of your conversation! To do this, simply ask Ordalie to generate a document by specifying the desired result as precisely as possible. The more precise you are, the better the result will be!',
		rech4title: 'Load an old conversation',
		rech4desc:
			'Load an old conversation from the chat history. The button is located in the top right corner of the chat window.',
		notesCat: 'Manage your notes',
		notes1title: 'Add a note',
		notes1desc:
			'Display one of the sources (article, jurisprudence...) from your searches, then click on the 📎 icon in the top right corner of the mini-window. You can also add a comment and a tag for better organization.',
		notes2title: 'Find and consult your notes',
		notes2desc:
			'Finally, find all your notes in the <a href="/app/search">notes</a> section of your account.',
		docsCat: 'Manage your documents',
		docs1title: 'Import a document',
		docs1desc:
			'Import any document into Ordalie — all formats are accepted (pdf, docx, jpeg...) ! You will then be able to add them to the sources, analyze them, or even modify them using the IA.',
		docs2title: 'Use an imported document as a source',
		docs2desc:
			'Complete the millions of sources already available on Ordalie by adding your own imported documents! You will then be able to use them in your searches and cite them in your generated documents. <br> The documents are imported into a completely isolated and secure space, and are never shared with other users 🔒',
		docs2video: 'tutorial_medias/docs2.mp4',
		analyseCat: 'Analyze your documents',
		analyse1title: 'Summarize an imported document',
		analyse1desc:
			'Use the summary feature to get a concise overview of an imported document. You have the choice between 4 levels of complexity, depending on your needs!',
		analyse1video: 'tutorial_medias/analyse1.mp4',
		analyse2title: 'Analyze an imported document',
		analyse2desc:
			'Use the analysis tools to study an imported document (compliance, extraction of dates, specific questions). Ordalie will quote the lines of the document used to answer your questions.',
		analyse2video: 'tutorial_medias/analyse2.mp4',
		genCat: 'AI-assisted writing',
		gen1title: 'Generate a document',
		gen1desc:
			'Use the generation button to create a contract or legal document from scratch. You can also add up to 3 reference documents to guide the AI in its writing. <br> The more precise you are in your request, the better the result will be!',
		gen1video: 'tutorial_medias/gen1.mp4',
		gen2title: 'Rewrite a passage of a document',
		gen2desc:
			'Use the rewrite feature to modify a passage of an existing document by highlighting. Several quick access buttons are available to help you rewrite in several ways.',
		gen2video: 'tutorial_medias/gen2.mp4',
		gen3title: 'Generate a new passage in a document',
		gen3desc:
			'Use the generation feature to add a new passage to an existing document. The more precise you are in your request, the better the result will be!',
		gen4title: 'Generate from your similar passages',
		gen4desc:
			'Ordalie allows you to generate or rewrite a passage from other similar passages found in your imported documents. <br> To do this, select a passage and click on the "Search similar passages" button. You will then have the possibility to navigate through the different passages found in your contracts and select the one that best suits you to perform the generation.',
		gen4video: 'tutorial_medias/gen4.mp4',
		sourceCat: 'Manage your sources',
		source1title: 'Add internet sites to the sources',
		source1desc:
			'Add internet sites to the sources of Ordalie to use them as a reference during your searches and legal analyses. <br> To do this, access <a href="/settings">"My account"</a>, click on the "Manage sources" button and add a new source by clicking on the "Add" button under the "Internet sites" section.<br> In the free version, you are limited to 2 indexed internet sites.',
		source2title: 'Activate/deactivate legal sources',
		source2desc:
			'Modify the legal sources provided by Ordalie. <br> To do this, access <a href="/settings">"My account"</a>, click on the "Manage sources" button and select the sources you want to disable or activate.',
		compteCat: 'Manage your Ordalie account',
		compte1title: 'Get your invoices',
		compte1desc:
			"Access your invoices history and manage your subscriptions using the button labeled <i>My customer account</i> in the <a href='/app/settings'>account</a> section.<br> This button will redirect you to the page for managing your customer account on a secure platform from our partner Stripe.",
		compte1video: 'tutorial_medias/compte1.mp4'
	},
	config: {
		editTitleOrContent: 'You can edit the titles/contents of the sections or reorder them.'
	},
	legal: {
		title: 'Legal',
		termsOfService: 'Terms of Service',
		privacyPolicy: 'Privacy Policy',
		termsOfSale: 'Terms of Sale',
		cgu: 'Terms of Use',
		privacy: 'Privacy Policy',
		cgv: 'Terms of Sale'
	},
	wordalie: {
		views: 'Views',
		file: 'File',
		font: 'Font',
		paragraph: 'Paragraph',
		styling: 'Styling',
		comment: 'Comment',
		edit: 'Edit',
		voice: 'Voice',
		aiTools: 'AI tools',
		tools: 'Tools',
		download: 'Download',
		undo: 'Undo',
		redo: 'Redo',
		bold: 'Bold',
		italic: 'Italic',
		underline: 'Underline',
		strike: 'Strike',
		bulletList: 'Bullet List',
		numberedList: 'Numbered List',
		showComments: 'Show Comments',
		newComment: 'New Comment',
		trackChanges: 'Track Changes',
		dictate: 'Dictate',
		aiWriting: 'AI Writing',
		align: 'Alignment',
		alignLeft: 'Align Left',
		alignCenter: 'Center',
		alignRight: 'Align Right',
		alignJustify: 'Justify',
		indent: 'Increase Indent',
		outdent: 'Decrease Indent',
		saving: 'Saving...',
		saved: 'Saved',
		saveFile: 'Save File',
		added: 'Added',
		removed: 'Removed',
		replaced: 'Replaced',
		with: 'with',
		openInEditor: 'Open in Editor',
		acceptAllChanges: 'Accept all changes',
		rejectAllChanges: 'Reject all changes'
	},
	security: {
		title: 'Security Measures',
		info: 'Security Information',
		dataLocation: 'All data hosted exclusively in France',
		encryption: 'End-to-end encrypted data flows and storage',
		lastAuditDate: 'Last security audit:',
		noDataReuse: 'No data reuse for AI training or third parties',
		trustCenter: 'Trust Center'
	},
	actions: {
		edit: 'Edit',
		cancel: 'Cancel',
		save: 'Save',
		remove: 'Remove',
		invite: 'Invite',
		sending: 'Sending...',
		loading: 'Loading...',
		creating: 'Creating...',
		createOrganization: 'Create Organization',
		addEmail: 'Add Email',
		subscribe: 'Subscribe'
	},
	share: {
		share: 'Share',
		teamMembers: 'Team Members',
		inviteByEmail: 'Invite by Email',
		public: 'Public',
		emailAddress: 'Email Address',
		enterEmailPlaceholder: 'Enter email address',
		searchMembersPlaceholder: 'Search members...',
		unnamedUser: 'Unnamed User',
		noMembersFound: 'No members found',
		searchMembers: 'Search for team members',
		noOrgMembers: 'No organization members found',
		publicShareInfo: 'Anyone with the link can access this content',
		accessLevel: 'Access Level',
		view: 'Viewer',
		edit: 'Editor',
		publicAccess: 'Public access',
		sharing: 'Sharing',
		whoHasAccess: 'Who has access',
		organization: 'Organization',
		unknownUser: 'Unknown User',
		removeAccessFor: 'Remove access for {target}',
		shareSuccess: 'Successfully shared',
		removeSuccess: 'Access removed successfully',
		errorLoadingShares: 'Error loading shares',
		errorLoadingMembers: 'Error loading team members'
	},
	cookies: {
		bannerTitle: 'Hey there! 🍪',
		bannerDescription: 'We waited to make sure you were interested in what Ordalie offers before mentioning cookies. We use them to keep you logged in and understand how to make our platform better. Your data stays in France and is never shared with third parties.',
		bannerQuestion: 'Is that okay with you?',
		cookiePurposeTitle: 'Purpose:',
		cookiePurposeList: 'Session management and login persistence;Usage analytics for platform improvement',
		customizeButton: 'Let me choose',
		rejectButton: 'No thanks',
		acceptAllButton: 'That\'s fine',
		preferencesTitle: 'Cookie Preferences',
		closeDetailsLabel: 'Close details',
		essentialCookiesTitle: 'Essential Cookies',
		essentialCookiesDescription: 'These keep you logged in and make sure Ordalie works properly. We can\'t turn these off.',
		analyticsCookiesTitle: 'Analytics Cookies',
		analyticsCookiesDescription: 'These help us understand what you find useful so we can make Ordalie even better for legal professionals like you.',
		rejectAllButton: 'Reject All',
		savePreferencesButton: 'Save Preferences',
		privacyPolicyText: 'By continuing to use our site, you accept our',
		privacyPolicyLink: 'privacy policy',
		preferencesSuccess: 'Preferences saved',
		settingsTitle: 'Cookie Management',
		settingsDescription: 'Manage your cookie preferences to customize your experience while respecting your privacy.',
		essentialSettingsDescription: 'Cookies necessary for site functionality (authentication, security, preferences)',
		analyticsSettingsDescription: 'Anonymous usage collection, error tracking and performance measurement to improve our service',
		alwaysEnabled: 'Always enabled',
		enabled: 'Enabled',
		disabled: 'Disabled',
		activeServices: 'Active services: behavioral analysis, error detection, performance metrics',
		lastUpdated: 'Last updated',
		version: 'Version',
		toggleLabel: 'Toggle analytics cookies',
		analyticsEnabled: 'Analytics cookies enabled',
		analyticsDisabled: 'Analytics cookies disabled'
	}
};

export default translations;
